var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',[_c('router-link',{staticClass:"align-center background-color-seashell d-inline-flex font-size-sm nav-button-border-radius pl-1 pr-3",attrs:{"to":{
        name: 'department',
        params: { departmentId: _vm.$route.params.departmentId },
      }}},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("mdi-chevron-left")]),_vm._v(" Back to "+_vm._s(_vm.textContent)+" Page ")],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }